import focus from './focus'
import hasPermission from './hasPermission'
import whenScrollEnds from './whenScrollEnds'
import loadButton from './loadButton'
import focusEl from './focusEl'
import clickOutside from './clickOutside'
import { mask } from 'src/common/mask'

const globalDirectives = [
  ['has-permission', hasPermission],
  ['focus-el', focusEl],
  ['focus', focus],
  ['click-outside', clickOutside],
  ['when-scroll-ends', whenScrollEnds],
  ['load-button', loadButton],
  ['mask', mask]
]

export const installDirectives = (app) => {
  globalDirectives.forEach(([name, directive]) => {
    app.directive(name, directive)
  })
}
